import { Badge, Group } from '@/components/ui';
import { TYPE_COLORS } from '../utils/qrCodeConstants';
import { QrCodeTypeIcon } from './QrCodeTypeIcon';

interface QrCodeTypeBadgeProps {
  type: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}

export function QrCodeTypeBadge({ type, size = 'sm' }: QrCodeTypeBadgeProps) {
  return (
    <Badge
      color={TYPE_COLORS[type] || 'gray'}
      size={size}
      variant="light"
      leftSection={<QrCodeTypeIcon type={type} size={12} />}
    >
      {type}
    </Badge>
  );
}
